<template>
  <v-container fluid grid-list-md>
    <h1>{{ $t('Application.cart') }}</h1>
    <v-data-table
      :headers="headers"
      :items="cart.items"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="state.pagination"
      :total-items = "state.pagination.totalItems"
      must-sort
      disable-initial-sort
      hide-actions
      class="elevation-1 mt-3"
      @update:pagination="onUpdatePagination"
    >

      <template slot="headerCell" slot-scope="props">
        <span>{{ $t(props.header.text) }}</span>
      </template>

      <template slot="items" slot-scope="props">
        <td>{{ props.item.itemnum }}</td>
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right" style="color: #2196F3">
          <NumericInput :value="items[props.item.itemnum]" button-width="21px" :min="1" style="width: 100px"
                        @input="onQtyChanged(props.item, $event)">
          </NumericInput>
        </td>
        <td class="text-xs-right">{{ props.item.taxrate.toLocaleString($i18n.locale) }}</td>
        <td class="text-xs-right">{{ props.item.sellingprice.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
        <td class="text-xs-right">{{ props.item.nettotal.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
        <td class="text-xs-center">
          <v-btn :flat="true" @click="removeItem(props.item)" color="info" small style="min-width: 40px">
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="footer" v-if="cart.items.length > 0">
        <td class="grey subheading"><strong>{{ $t('Common.total') }}</strong></td>
        <td class="grey"></td>
        <td class="grey"></td>
        <td colspan="2" class="grey text-xs-right caption">
          <div>{{ $t('Common.netAmount')}} :</div>
          <div>{{ $t('Common.taxAmount')}} :</div>
          <div>{{ $t('Common.grossAmount')}} :</div></td>
        <td class="grey text-xs-right">
          <div>{{ cart.netamount.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
          <div>{{ cart.tax.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
          <div>{{ cart.total.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
        </td>
        <td class="grey"></td>
      </template>

    </v-data-table>

    <div class="mt-4">
      <v-btn class="ml-0" color="warning" @click="clearCart">{{ $t('Action.clearCart') }}</v-btn>
      <v-btn color="success" @click="openPlaceOrderDialog">{{ $t('Action.placeOrder') }}</v-btn>
    </div>

    <ConfirmDialog
      v-if="placeOrderDialog" @close="closePlaceOrderDialog"
      :messages="placeOrderMessages">
    </ConfirmDialog>

  </v-container>
</template>

<script>
  import store from '../store'
  import NumericInput from '../components/NumericInput'
  import ConfirmDialog from '../components/ConfirmDialog'

  export default {
    name: 'Cart',
    components: {
      NumericInput,
      ConfirmDialog
    },
    watch: {
      items: {
        handler: function (value) {
          this.refresh();
        },
        deep: true
      }
    },
    computed: {
      state() {
        return store.cart;
      },
      placeOrderMessages() {
        const messages = this.$i18n.messages[this.$i18n.locale].Cart.PlaceOrder;
        messages.text = messages.text.replace('{0}', this.$root.config.placeOrderTermsOfService)
        return messages;
      }
    },
    data: () => {
      return {
        headers: [
          {text: 'Common.itemNum', value: 'itemnum', align: 'left'},
          {text: 'Common.itemName', value: 'name', align: 'left'},
          {text: 'Common.quantity', value: 'amount', align: 'center', width: '100px'},
          {text: 'Common.taxPercent', value: 'taxrate', align: 'right'},
          {text: 'Common.itemPrice', value: 'sellingprice', align: 'right'},
          {text: 'Common.total', value: 'nettotal', align: 'right'},
          {text: 'Action.remove', align: 'center', sortable: false, width: '40px'}
        ],
        cart: {
          netamount: 0,
          tax: 0,
          total: 0,
          taxAmounts: {},
          taxes: {},
          items: []
        },
        rowsPerPageItems: [{ "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }],
        placeOrderDialog: false
      };
    },
    props: {
      items: {
        type: Object
      }
    },
    mounted() {
      console.log('Mount Cart');
      this.refresh();
    },
    methods: {
      refresh() {
        this.$http.post(this.$root.route('cart'), {items: this.items}).then(
          response => {
            console.log('Success', response);
            this.cart = response.body.result;
            this.cart.items.forEach(item => {
              item.total = Math.round((item.nettotal + item.taxamount) * 1000000) / 1000000
            })
            this.state.pagination.totalItems = response.body.result.count;
          },
          response => {
            console.log('Fail', response);
          });
      },
      onUpdatePagination(paginationObject) {
        Object.keys(paginationObject).forEach(key => this.state.pagination[key] = paginationObject[key]);
        this.refresh()
      },
      clearCart() {
        this.$emit('clear');
      },
      openPlaceOrderDialog() {
        this.placeOrderDialog = true;
      },
      closePlaceOrderDialog(confirmed) {
        this.placeOrderDialog = false;
        if (confirmed) {
          this.placeOrder();
        }
      },
      placeOrder() {
        this.$http.post(this.$root.route('order'), {items: this.items}).then(
          response => {
            console.log('Success', response);
            this.clearCart();
          },
          response => {
            console.log('Fail', response);
          });
      },
      removeItem(item) {
        this.onQtyChanged(item, 0)
      },
      onQtyChanged(item, value) {
        this.$set(this.items, item.itemnum, value);
      }
    }
  }
</script>

<style lang="scss">
  th.column.sortable.text-xs-center {
    padding-left: 8px;
  }
</style>
